import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import {
    capitalize,
    combineClasses,
} from 'wanderu-css';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './Avatar.scss';

function Avatar(props) {
    const {
        classes: classesProp = {},
        className,
        color = 'initial',
        component: Component = 'span',
        componentProps,
        variant = 'circle',
        ...otherProps
    } = props;

    const classes = combineClasses(styles, classesProp);

    return (
        <Component
            className={clsx(
                classes.root,
                {
                    [classes[`color${capitalize(color)}`]]: color !== 'initial',
                    [classes[variant]]: variant !== 'circle',
                },
                className,
            )}
            {...otherProps}
            {...componentProps}
        />
    );
}

Avatar.propTypes = {
    /**
     * The content of the component.
     */
    children: PropTypes.node.isRequired,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * The color of the component. It supports those theme colors that make sense for this component.
     */
    color: PropTypes.oneOf([
        'initial',
        'inherit',
        'primary',
        'secondary',
        'error',
    ]),
    /**
     * The component used for the root node.
     * Either a string to use a HTML element or a component.
     */
    component: PropTypes.elementType,
    /**
     * The set of components passed down to the root component
     */
    componentProps: PropTypes.object,
    /**
     * Used to control the text styling.
     */
    variant: PropTypes.oneOf(['circle', 'square']),
};

export default Avatar;
